<template>
  <sidenav :orientation="orientation" :class="curClasses">

    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">

      <sidenav-router-link icon="fa fa-home" to="/anasayfa" :exact="true">Ana Sayfa</sidenav-router-link>

      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA"
                           icon="fas fa-chart-line" to="/rapor"
                           :exact="true">Rapor
      </sidenav-router-link>

      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-edit" class=""
                           to="/kisi/liste"
                           :exact="true">Koordinatörler ve Hocalar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-edit" class=""
                           to="/kisi/sertifika"
                           :exact="true">Yaz okulu görevlilerine sertifika gönderme
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki === Yetki.HOCA" icon="fa fa-user"
                           to="/ogrenci/liste"
                           :exact="true">Öğrencilerim
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-user"
                           to="/ogrenci/liste"
                           :exact="true">Öğrenciler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-file-excel"
                           to="/ogrenci/excel-ekleme"
                           :exact="true">Excel'den Öğrenci Ekleme
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fas fa-sms"
                           to="/toplu-sms"
                           :exact="true">Toplu SMS
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-user"
                           to="/ogrenci/liste?silinenlerMi=true"
                           :exact="true">Silinen Öğrenciler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki === Yetki.SUPERADMIN || kullaniciId === 4996" icon="fas fa-mosque"
                           to="/medreseli-talebe/liste"
                           :exact="true">Medreseli Talebeler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE" icon="fas fa-book" to="/sinif/liste" :exact="true">
        Sınıflar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA"
                           icon="fas fa-calendar-alt"
                           to="/baslayacak-devam-edenler"
                           :exact="true">Başlayacaklar ve Devam Edenler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE" icon="fas fa-folder" to="/dosyalar"
                           :exact="true">Dosyalar
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-book" to="/odevler"
                           :exact="true">Ödevler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE" icon="fas fa-clock" to="/etkinlikler"
                           :exact="true">Etkinlikler
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki === Yetki.TALEBE" icon="fas fa-user" to="/profilim"
                           :exact="true">Profilim
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki === Yetki.SUPERADMIN" icon="fas fa-file-excel" to="/raporlarim"
                           :exact="true">Raporlarım
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciCinsiyet === 2" icon="fas fa-list" to="/seminerler"
                           :exact="true">Seminerler
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-phone" v-if="kullaniciYetki === Yetki.TALEBE" to="/iletisim"
                           :exact="true">İletişim
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-mosque" v-if="kullaniciYetki !== Yetki.TALEBE" to="/inayet-tasarruf"
                           :exact="true">İnayet-Tasarruf
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-file-image" v-if="kullaniciYetki !== Yetki.TALEBE && sertifikaOlusturucuGozuksunMu" to="/sertifika"
                           :exact="true">Sertifika Oluşturucu
      </sidenav-router-link>
      <sidenav-router-link icon="fas fa-file-image" v-if="kullaniciYetki !== Yetki.TALEBE && sertifikaOlusturucuGozuksunMu" to="/toplu-sertifika"
                           :exact="true">Toplu Sertifika Oluşturucu
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-globe"
                           to="/yuzyuze-egitim-yerler"
                           :exact="true">Yüzyüze Eğitim İlçeleri
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-home"
                           to="/okullar"
                           :exact="true">Yüzyüze Eğitim Okullar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-school"
                           to="/temizlik-gorevlisi-icin-okullar"
                           :exact="true">Temizlik Görevlisi İçin Okullar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-clock"
                           to="/seanslar"
                           :exact="true">Yüzyüze Eğitim Seanslar
      </sidenav-router-link>
      <sidenav-router-link v-if="kullaniciYetki !== Yetki.TALEBE && kullaniciYetki !== Yetki.HOCA" icon="fa fa-clock"
                           to="/iletisim-bilgileri"
                           :exact="true">İletişim Bilgileri
      </sidenav-router-link>
    </div>
  </sidenav>
</template>

<script>
import {
  Sidenav,
  SidenavLink,
  SidenavRouterLink,
  SidenavMenu,
  SidenavHeader,
  SidenavBlock,
  SidenavDivider
} from '@/vendor/libs/sidenav'
import { getCinsiyet, getID, getRole } from '@/utils/jwtOperations'
import { Yetki } from '@/utils/enums'

export default {
  name: 'app-layout-sidenav',
  data () {
    return {
      kullaniciYetki: 0,
      kullaniciCinsiyet: getCinsiyet(),
      kullaniciId: 0,
      Yetki,
      sertifikaOlusturucuGozuksunMu: true
    }
  },
  components: {
    /* eslint-disable vue/no-unused-components */
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
    /* eslint-enable vue/no-unused-components */
  },

  props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
  },

  computed: {
    curClasses () {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }

      return `bg-${bg} ` + (
        this.orientation !== 'horizontal'
          ? 'layout-sidenav'
          : 'layout-sidenav-horizontal container-p-x flex-grow-0'
      )
    }
  },

  methods: {
    tiklandi () {
    },
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  },
  mounted () {
    this.kullaniciYetki = getRole()
    this.kullaniciId = getID()
    const date = new Date()
    let sertifikaBaslangicTarihi = new Date(2021, 6, 16, 0, 0, 0, 0)
    if (this.proje2022Mi) {
      sertifikaBaslangicTarihi = new Date(2022, 7, 16, 0, 0, 0, 0)
    }
    if (date >= sertifikaBaslangicTarihi) {
      this.sertifikaOlusturucuGozuksunMu = true
    }
  }
}
</script>
